module.exports = __webpack_public_path__ + "static/media/insturctor6.32cd6a5a.png";